import React from 'react';

export default function ModalImage({content}) {
    return (
        <img 
        src={content.image.src}
        alt={content.image.alt}
        className={`mx-auto h-auto w-auto max-h-full max-w-full object-contain`}
        loading="lazy"
        />
    )
}